import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';

export type AppSwitchFieldProps = {
  label: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

const AppSwitchField: React.FC<AppSwitchFieldProps> = ({
  label,
  checked,
  onChange,
  className = '!ml-0'
}) => (
  <FormControlLabel
    className={className}
    control={
      <Switch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
    }
    label={label}
  />
);

export default AppSwitchField;
